import { transformErrorResponse } from "../../transformErrorResponse"
import { AuthApiBuilder } from "."

export const usuariosautoinventario = (build: AuthApiBuilder) => {
    return {
        verifyAutoInventario: build.mutation<boolean, any[]>({
            query: (body) => ({
                url: `maestros/usuariosautoinventario/verify`,
                method: "POST",
                body,
            }),
            transformErrorResponse
        }),
    }
}